import { render } from "./AddPlatFormLevel.vue?vue&type=template&id=1d2a78ca&scoped=true"
import script from "./AddPlatFormLevel.vue?vue&type=script&lang=js"
export * from "./AddPlatFormLevel.vue?vue&type=script&lang=js"

import "./AddPlatFormLevel.vue?vue&type=style&index=0&id=1d2a78ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2a78ca"]])

export default __exports__